import React from "react";
import {EMPTY_TRAIN_CAR_TYPE, Variables} from "../../../gameplay/model/Balance";
import {CARGO_HEADER_COLORS} from "../GameStyleUI";
import {CargoNames, CLIENT_NAMES} from "../../../constants/Constants";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import GameData from "../../../gameplay/model/GameData";

export default class TrainCarPackCard extends React.Component {
    calcWeight(){
        let trainCarPack = GameData.CurrentGame.getTrainCarById(this.props.trainCarsPack);
        return (trainCarPack.type === EMPTY_TRAIN_CAR_TYPE ?
            Variables.trainCarWeight : Variables.trainCarLiftingCapacity)
            * trainCarPack.trainCarCount;
    }
    onCardClick(){
        if (this.props.onClick)
            this.props.onClick(this.props.trainCarsPack);
    }
    render() {
        let mainStyle = {
            width: "143px",
            height: "95px",
            paddingRight: "10px"
        }
        let headerStyle = {
            display: "flex",
            width: "100%",
            justifyContent: "space-between"
        }
        let headerPaddings = {
            padding: "10px",
            paddingTop: "6px",
            width: "123px"
        }
        let TextLine1 = {
            lineHeight: "10px",
            fontSize: "8px",
            fontWeight: "normal",
            textTransform: "uppercase"
        }
        let TextLine2 = {
            lineHeight: "18px",
            fontSize: "14px",
            fontWeight: "bold",
            textTransform: "uppercase"
        }
        let textPaddings = {
            padding: "10px"
        }
        let delimeterStyle = {
            width: "143px",
            height: "1px",
            marginTop: "10px",
            background: "rgba(3, 3, 3, 0.3)"
        }
        let trainCarPack =  GameData.CurrentGame.getTrainCarById(this.props.trainCarsPack);
        let colors = CARGO_HEADER_COLORS(trainCarPack.type)
        let header = [];
        header.push(<div style={headerStyle} key={'header-1'}>
            <div style={{...TextLine1, color: "white"}}>Клиент</div>
            <div style={{...TextLine1, color: "white"}}>Код</div>
        </div>);
        header.push(<div style={headerStyle} key={'header-2'}>
            <div style={{...TextLine2, color: "white"}}>{CLIENT_NAMES[trainCarPack.client]}</div>
            <div style={{...TextLine2, color: "white"}}>{trainCarPack.orderCode}</div>
        </div>);
        header = <div style={headerPaddings}>{header}</div>

        let content = [];
        content.push(<div style={textPaddings} key={'content-1'}>
            <div style={{...TextLine1, textAlign: "center"}}>тип груза</div>
            <div style={{...TextLine2, textAlign: "center"}}>{CargoNames[trainCarPack.type]}</div>
        </div>);
        content.push(<div style={delimeterStyle} key={'content-2'} />);
        content.push(<div style={{display: "flex", justifyContent: "space-between"}} key={'content-3'}>
          <div style={textPaddings}>
            <div style={{...TextLine1, textAlign: "left"}}>ТОННАЖ</div>
            <div style={{...TextLine2, textAlign: "left"}}>{this.calcWeight()}</div>
        </div>
        <div style={{...textPaddings, paddingBottom: 0}}>
            <div style={{...TextLine1, textAlign: "right"}}>вагоны</div>
            <div style={{...TextLine2, textAlign: "right"}}>{trainCarPack.trainCarCount}</div>
        </div></div>);
        return <div style={{...mainStyle, ...this.props.style}} onClick={this.onCardClick.bind(this)}>
            <GameWindowHeader width={143} height={40} colorStart={colors[0]} colorEnd={colors[1]} customContent={header} />
            <GameWindowBg width={143} height={110} value={content}/>
        </div>;
    }
}
